import { createStackNavigator } from '@react-navigation/stack';
import AssignedDevicesList from './AssignedDevicesList';
import { DeviceInvoicesList } from './DeviceInvoicesList';

const Stack = createStackNavigator();

const ViewAssignedDevices = () => {




    return <Stack.Navigator
        screenOptions={{
            headerShown: false,

        }}
    >
        <Stack.Screen
            name="DeviceInvoicesList"
            component={DeviceInvoicesList}

        />
        <Stack.Screen
            name="AssignedDevicesList"
            component={AssignedDevicesList}

        />

    </Stack.Navigator>

}

export default ViewAssignedDevices;


